import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Load the Meta Pixel only once the page is idle so it never competes
    // with the hero rendering.
    const start = () => initMetaPixel();
    const scope = window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    const useIdle = typeof scope.requestIdleCallback === 'function';
    const id = useIdle ? (scope.requestIdleCallback as (cb: () => void, opts?: {
      timeout: number;
    }) => number)(start, {
      timeout: 3000
    }) : window.setTimeout(start, 1800);
    return () => {
      if (useIdle && typeof scope.cancelIdleCallback === 'function') {
        scope.cancelIdleCallback(id);
      } else {
        window.clearTimeout(id);
      }
    };
  }, []);
  return <div className="w-full min-h-full bg-bone font-sans text-court-950 antialiased" data-id="element-0" data-mp="33n6y54p9hv5d">
      <Hero data-id="element-1" data-mp="38l03xwmnkn54" />
      <main data-id="element-2" data-mp="38k6w0sbyjrle">
        <div className="defer-paint" data-id="element-3" data-mp="38nup5qdhqbzl">
          <Problems data-id="element-4" data-mp="3dle1gkqmoeow" />
          <SystemOverview data-id="element-5" data-mp="3dlw5i3jj7x7d" />
          <Bonuses data-id="element-6" data-mp="3dm5y7yvyoigr" />
        </div>
        <OfferSection data-id="element-7" data-mp="nvj179a902mk" />
        <div className="defer-paint" data-id="element-8" data-mp="nwc2vvuco1xu">
          <Comparison data-id="element-9" data-mp="nvar1p5ifbf2" />
          <Testimonials data-id="element-10" data-mp="nxx0jubyo0zx" />
          <Guarantee data-id="element-11" data-mp="su43rfcz2ye6" />
          <Faq data-id="element-12" data-mp="stkj3qvxtvwg" />
          <FinalCta data-id="element-13" data-mp="st2hsfuf4rho" />
        </div>
      </main>
      <Footer data-id="element-14" data-mp="36877lhgoowl" />
      <PurchasePopup data-id="element-15" data-mp="35ozexlizgwa" />
    </div>;
}